import React, { useState } from "react";
import { useApolloClient } from "@apollo/react-hooks";
import { RouteComponentProps, withRouter } from "react-router";
import { Avatar } from "@sonder/ui/source/icons";
import {
  UserMenu as SonderUserMenu,
  UserMenuTrigger,
} from "@sonder/ui/source/styled/components/UserMenu";
import { SidebarButton } from "@sonder/ui/source/styled/fragments/Sidebar";
import { useSegment } from "analytics/segment";
import { useLoggedInUser } from "auth/hooks";
import { isOktaEnabled, useLogout } from "auth/utils/oktaAuth";
import { useErrorReporter } from "core/hooks/useErrorReporter";
import { EditProfileModal } from "users/components/EditProfileModal";

const SEGMENT_COMPONENT_NAME = "user_menu";

export const UserMenuSimple = ({ history }: RouteComponentProps) => {
  const errorReporter = useErrorReporter();
  const { track, reset } = useSegment();
  const { logout } = useLogout();
  const client = useApolloClient();
  const { user, error, loading } = useLoggedInUser();
  const [isEditProfileModalOpen, setEditProfileModalOpen] = useState(false);

  if (error) return <span>Error</span>;
  return (
    <>
      {user && (
        <EditProfileModal
          isOpen={isEditProfileModalOpen}
          user={user}
          onClose={() => {
            setEditProfileModalOpen(false);
          }}
        />
      )}
      <SonderUserMenu
        loading={loading}
        renderTrigger={() =>
          !loading && user ? (
            <UserMenuTrigger
              data-cy="UserMenuTrigger"
              imageUrl={user.avatarUrl}
              name={user.name}
            />
          ) : (
            <SidebarButton disabled>
              <Avatar />
            </SidebarButton>
          )
        }
        onClose={() =>
          track({
            eventName: SEGMENT_COMPONENT_NAME,
            action: "click",
            element: "user_menu.dropdown_trigger",
            props: { nextValue: "closed" },
          })
        }
        onEditProfile={() => {
          track({
            eventName: SEGMENT_COMPONENT_NAME,
            action: "click",
            element: "edit_profile_button",
          });
          setEditProfileModalOpen(true);
        }}
        onLogout={() => {
          track({
            eventName: SEGMENT_COMPONENT_NAME,
            action: "click",
            element: "logout_button",
          });
          // Clear common props on logout
          reset();
          client.clearStore();
          // Clear user from errorReporter
          errorReporter.setUser({});
          // Wipe Okta
          logout();
          if (!isOktaEnabled) history.push("/logout");
        }}
        onOpen={() =>
          track({
            eventName: SEGMENT_COMPONENT_NAME,
            action: "click",
            element: "user_menu.dropdown_trigger",
            props: { nextValue: "opened" },
          })
        }
      />
    </>
  );
};

export const UserMenu = withRouter(UserMenuSimple);
